import * as React from 'react';
import { Text } from 'react-native';

export function TraxxText(props: any) {
  return <Text style={[{ fontFamily: 'PoppinsRegular', fontSize: 14 }, props.style]}>{props.children}</Text>;
}
